
















































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { OperatorModel, OperatorProperty } from '@/models/Operator';
import { GroupModel } from '@/models/Group';
import GroupCard from '@/components/GroupCard.vue';
import { BaseGroupingStrategy, RandomGroupingStrategy, BalancedGroupingStrategy } from '@/helper/groupingStrategy';
import { BaseDecideOddsStrategy, BalancedOddsStrategy, RarityDependedOddsStrategy } from '@/helper/decideOddsStrategy';

const operatorModule = namespace('OperatorStore');
const groupModule = namespace('GroupStore');

@Component({
  components: {
    GroupCard,
  },
})
export default class Operators extends Vue {
    @groupModule.State private groups!: GroupModel[];

    @groupModule.State private groupingStrategy!: BaseGroupingStrategy;

    @groupModule.State private decideOddsStrategy!: BaseDecideOddsStrategy;

    @operatorModule.Getter('isTargetGrouping') private targetOperators!: OperatorModel[];

    @groupModule.Action('reset') private reset!: (isForce: boolean) => void;

    @groupModule.Action('setGroup') private setGroup!: (groups: GroupModel[]) => void;

    @groupModule.Action('changeGroupingStrategy') private changeGroupingStrategy!: (groupingStrategy: BaseGroupingStrategy) => void;

    @groupModule.Action('changeOddsStrategy') private changeOddsStrategy!: (oddsStrategy: BaseDecideOddsStrategy) => void;

    private operatorNum: number = 3;

    private groupingStrategySettings: { disp: string, prop: OperatorProperty; isValid: boolean }[] = [
        { disp: 'ジョブ', prop: 'job', isValid: false },
        { disp: '職分', prop: 'detailJob', isValid: false },
        { disp: 'レア', prop: 'rarity', isValid: false }
    ];

    private decideOddsStrategyId: string = '1';

    protected created() {
        this.reset(false);
        this.setGroupingStrategy();
        this.setDecideOddsStrategy();
    }

    private setGroupingStrategy() {
        let groupingStrategy: BaseGroupingStrategy;
        const validSettings = this.groupingStrategySettings.filter((setting) => setting.isValid);
        if (validSettings.length === 0) {
            groupingStrategy = new RandomGroupingStrategy(this.targetOperators, this.operatorNum);
        } else {
            const validProps: OperatorProperty[] = validSettings.map((setting) => setting.prop);
            groupingStrategy = new BalancedGroupingStrategy(this.targetOperators, this.operatorNum, validProps);
        }
        this.changeGroupingStrategy(groupingStrategy);
    }

    private setDecideOddsStrategy() {
        let decideOddsStrategy: BaseDecideOddsStrategy = new BalancedOddsStrategy();;
        switch (this.decideOddsStrategyId) {
            case '1':
                decideOddsStrategy = new BalancedOddsStrategy();
                break;
            case '2':
                decideOddsStrategy = new RarityDependedOddsStrategy();
                break;
        }
        this.changeOddsStrategy(decideOddsStrategy);
    }

    get groupNum(): number {
        const modNum: number = this.targetOperators.length % this.operatorNum;
        return (this.targetOperators.length - modNum) / this.operatorNum;
    }

    private grouping(shouldGroupReset: boolean) {
        this.setGroupingStrategy();
        this.setDecideOddsStrategy();

        let groups: GroupModel[] = [];
        if (shouldGroupReset) {
            groups = this.groupingStrategy.grouping();
        } else {
            groups = JSON.parse(JSON.stringify(this.groups));
        }
        this.reset(true);
        this.decideOddsStrategy.decideOdds(groups);
        this.setGroup(groups.filter(group => group));
    }
}
